import React, { useContext, useEffect, useState } from 'react'
import Select from 'react-select'
import { CustomerContext } from '../../../contexts/CustomerContext'
import useSchools from '../../../hooks/useSchools'
import Typography from '../../Typography'
import classes from './schedule-appointment.module.sass'
import Button from '../../Button'
import Cart from '../../../models/Cart'
import StudentIdForm from '../../StudentIdForm'
import ShootingSchedule from '../../../models/ShootingSchedule'
import { routes } from '../../../routes'
import { SchoolType } from '../../../models/_models'
import { useHistory } from 'react-router-dom'
import useQueryString from '../../../hooks/use-query-string'
import OtherSchoolTypeForm from './OtherSchoolTypeForm';
import { toast, ToastContainer } from 'react-toastify';
import apptHeaderImg from './make-appt-header.jpg';
import seniorApptHeaderImg from './senior-appt-header.jpg';
import Package from '../../../models/Package';
import { OrderPackage, Student } from '../../../models';
import SeniorCarousel from './SeniorCarousel';

const SCHEDULE_AT_SCHOOL = 'SCHEDULE_AT_SCHOOL'
const SCHEDULE_AT_SHOOB = 'SCHEDULE_AT_SHOOB'
const NO_SCHEDULES_AVAILABLE = 'NO_SCHEDULES_AVAILABLE'

export const customStyles = {
  control: (provided) => ({
    ...provided,
    border: '1px solid #aaa',
    borderRadius: 0,
    minHeight: 48,
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
};

const ScheduleAppointment = () => {
  const { customer, setCustomer } = useContext(CustomerContext)
  const history = useHistory()
  const { apptCart, currentSchool } = customer
  const schools = useSchools()
  const [school, setSchool] = useState('')
  const [email, setEmail] = useState(customer.email || '')
  const [studentId, setStudentId] = useState('');
  const [scheduleStatus, setScheduleStatus] = useState(SCHEDULE_AT_SCHOOL)
  const [step, setStep] = useState(0)
  const [schoolType, setSchoolType] = useState('')
  const { p: packageId, senior, message_id: messageId } = useQueryString()

  const apptText = senior ? 'Enter your information to view available appointments and schedule your Senior Portraits' : 'Enter your information to view available appointments for Studio Pictures';

  const [hasPackage, setHasPackage] = useState(true);
  const [apptPackage, setApptPackage] = useState();
  const [apptPackageLoading, setApptPackageLoading] = useState(false);
  // Inline lookup state for the student-id field. Lets us confirm the student
  // by name before the customer hits Continue (and cache the result so we
  // don't double-fetch on submit).
  // status: 'idle' | 'loading' | 'found' | 'not_found' | 'error'
  const [studentLookup, setStudentLookup] = useState({ status: 'idle', student: null, key: null });

  useEffect(() => {
    if (!school.value) return;
    /* should look for Fall E1 package for elementary */
    /* should look for appointment package / sittings for seniors */
    setApptPackage(undefined);
    setApptPackageLoading(true);
    const onErr = (err) => {
      console.error('appt package fetch failed', err);
      toast.error('Could not load appointment options. Please refresh and try again.', { autoClose: false });
      setApptPackageLoading(false);
    };
    if (packageId) {
      Package
        .find(packageId)
        .then((res) => {
          setApptPackageLoading(false);
          if (!res) {
            toast.error('There are no appointments available for your school at this time.', { autoClose: false });
            return;
          }
          setApptPackage(res.data);
        })
        .catch(onErr);
    } else if (schoolType.toLowerCase().includes('elementary')) {
      Package
        .where({ schoolId: school.id, elementarySittings: true })
        .all()
        .then((res) => {
          setApptPackageLoading(false);
          if (res.data.length < 1) {
            toast.error('There are no appointments available for your school at this time.', { autoClose: false });
            return;
          }
          setApptPackage(res.data[0]);
        })
        .catch(onErr);
    } else {
      Package
        .where({ schoolId: school.id, highSchoolSittings: true })
        .order({ shouldShowAppointments: false })
        .all()
        .then((res) => {
          setApptPackageLoading(false);
          if (res.data.length < 1) {
            toast.error('There are no appointments available for your school at this time.', { autoClose: false });
            return;
          }
          setApptPackage(res.data[0]);
        })
        .catch(onErr);
    }
  }, [school, schoolType]);

  useEffect(() => {
    async function getData() {
      if (!school) return

      const { data: schoolScheduleData } = await ShootingSchedule
        .where({ inFuture: true, schoolId: school.value })
        .all()

      const { data: shoobScheduleData } = await ShootingSchedule
        .where({ inFuture: true, schoolId: 1075 })
        .all()

      if (schoolScheduleData.length > 0) {
        setScheduleStatus(SCHEDULE_AT_SCHOOL)
      } else if (shoobScheduleData.length > 0) {
        setScheduleStatus(SCHEDULE_AT_SHOOB)
      } else {
        setScheduleStatus(NO_SCHEDULES_AVAILABLE)
      }
    }

    getData()
  }, [school])

  useEffect(() => {
    if (!school) return

    SchoolType
      .find(school.schoolTypeId)
      .then((res) => setSchoolType(res.data.name))
      console.log(schoolType);
  }, [school])

  let route
  if ([SCHEDULE_AT_SHOOB, NO_SCHEDULES_AVAILABLE].includes(scheduleStatus)) {
    const status = scheduleStatus === SCHEDULE_AT_SHOOB ? 0 : 1
    const t = schoolType.toLowerCase().includes('elementary') ? 0 : 1
    route = routes.scheduleAtShoob({ status, t, s: school.value, p: packageId })
  }

  // Cache key — invalidates when school or studentId changes.
  const lookupKey = school?.id && studentId ? `${school.id}:${studentId}` : null;

  // Look up the student by school + student_id and store the result so we can
  // (a) confirm the customer's identity inline before they click Continue,
  // and (b) skip a duplicate fetch on submit.
  // The is_enrolled filter that used to live on this query was excluding
  // transfers and make-up appointment seekers (the customers most likely to
  // need this form). school + student_id is enough for the studio-appt path.
  const lookupStudentByIdField = () => {
    if (!school?.id || !studentId) return;
    setStudentLookup({ status: 'loading', student: null, key: lookupKey });

    Student
      .where({ schoolId: school.id, studentId })
      .first()
      .then((res) => {
        if (res.data) {
          setStudentLookup({ status: 'found', student: res.data, key: lookupKey });
        } else {
          setStudentLookup({ status: 'not_found', student: null, key: lookupKey });
        }
      })
      .catch((err) => {
        console.error('student lookup failed', err);
        setStudentLookup({ status: 'error', student: null, key: lookupKey });
      });
  };

  const proceedWithStudent = (foundStudent) => {
    const orderPackage = new OrderPackage({
      package: apptPackage,
      packageId: apptPackage.id,
      student: foundStudent,
      studentId: foundStudent.id,
    });

    const selectedSchool = schools.find((sSchool) => sSchool.id === school.value);
    const onCartFail = (err) => {
      console.error('cart save failed', err);
      toast.error('We could not start your appointment. Please refresh and try again.', { autoClose: false });
    };

    if (apptCart) {
      apptCart.schoolId = school.id;
      apptCart.messageId = messageId;
      apptCart.save().then(() => {
        orderPackage.cartId = apptCart.id;
        setCustomer({ ...customer, currentSchool: selectedSchool, currentStudent: foundStudent, email, currentOrderPackage: orderPackage });
        history.push(routes.appointmentOptionSelection(apptPackage.id));
      }).catch(onCartFail);
    } else {
      const cart = new Cart({
        createdLocation: 'sittings',
        email,
        school: selectedSchool,
        schoolId: school.value,
        messageId,
      });
      cart.save().then(() => {
        orderPackage.cartId = cart.id;
        setCustomer({
          ...customer, apptCart: cart, email, currentSchool: selectedSchool, currentStudent: foundStudent, currentOrderPackage: orderPackage
        });
        history.push(routes.appointmentOptionSelection(apptPackage.id));
      }).catch(onCartFail);
    }
  };

  const submitHandler = (e) => {
    e.preventDefault();

    if (!school?.value) {
      toast.error('Please select your school.');
      return;
    }
    if (email === '') {
      toast.error('Please enter your email address');
      return;
    }
    if (studentId === '') {
      toast.error('Please enter a Student I.D. #');
      return;
    }
    if (apptPackageLoading) {
      toast.info('Loading appointment options for your school — please wait a moment and try again.');
      return;
    }
    if (!apptPackage) {
      toast.error('No appointment package is configured for your school. Please contact us at info@shoobphoto.com for help.', { autoClose: false });
      return;
    }

    // If we already looked up this exact student and have them cached, skip
    // the round-trip and proceed straight to checkout.
    if (studentLookup.key === lookupKey && studentLookup.status === 'found' && studentLookup.student) {
      toast.success('Redirecting you to package options…', { autoClose: 5000 });
      proceedWithStudent(studentLookup.student);
      return;
    }

    Student
      .where({ schoolId: school.id, studentId })
      .first()
      .then((res) => {
        if (!res.data) {
          setStudentLookup({ status: 'not_found', student: null, key: lookupKey });
          toast.error('We were unable to find your student with the given information. Please check the Student I.D. and try again.', { autoClose: false });
          return;
        }
        setStudentLookup({ status: 'found', student: res.data, key: lookupKey });
        toast.success('We found your student! Please wait while we redirect you to package options.', { autoClose: 10000 });
        proceedWithStudent(res.data);
      })
      .catch((err) => {
        console.error('student lookup failed', err);
        toast.error('Something went wrong looking up your student. Please refresh and try again.', { autoClose: false });
      });
  };

  return (
    <>
      <div className={`${classes.pageContainer} ${classes.senior}`}>
        {!senior && <img className={`${classes.desktopImg} ${classes.img}`} src={apptHeaderImg} />}
        {senior && <img className={`${classes.desktopImg} ${classes.img}`} src={seniorApptHeaderImg} />}
        {senior && <img className={`${classes.mobileImg} ${classes.img}`} src={seniorApptHeaderImg} />}
        <ToastContainer position="bottom-right" />
        <div className={classes.container}>
          <div className={classes.seniorApptText}>
            <p>{senior ? 'Book Senior Session' : 'Make an Appointment'}</p>
            <p>{apptText}</p>
          </div>
          <div>
            {step === 1 && schoolType !== 'Other' && hasPackage && (
              <Typography classes={classes.instructions} align="center">
                To view available appointments, enter student I.D.
              </Typography>
            )}
            {step === 0 && (
              <form onSubmit={submitHandler} className={classes.form}>
                <label className={`${classes.label} ${classes.select}`}>
                  <span>Your School:</span>
                  <Select
                    styles={customStyles}
                    defaultValue={school}
                    options={schools.map((sSchool) => ({
                      value: sSchool.id,
                      label: sSchool.name,
                      schoolTypeId: sSchool.schoolTypeId,
                      id: sSchool.id
                    }))}
                    onChange={setSchool}
                  />
                </label>
                <label className={classes.label}>
                  <span>Your Email Address:</span>
                  <input type="email" placeholder="Email" value={email} onChange={(evt) => setEmail(evt.target.value)} />
                </label>
                <label className={classes.label}>
                  <span>Student I.D. #:</span>
                  <input type="text" placeholder="Student I.D." value={studentId}
                         onChange={(e) => {
                           setStudentId(e.target.value);
                           // typing invalidates a stale lookup
                           if (studentLookup.status !== 'idle') setStudentLookup({ status: 'idle', student: null, key: null });
                         }}
                         onBlur={lookupStudentByIdField} />
                  {studentLookup.key === lookupKey && (
                    <small style={{ display: 'block', marginTop: 4, fontSize: 13 }}>
                      {studentLookup.status === 'loading' && (
                        <span style={{ color: '#475569' }}>Looking up student…</span>
                      )}
                      {studentLookup.status === 'found' && (
                        <span style={{ color: '#15803d' }}>
                          ✓ Found: {studentLookup.student.firstName} {studentLookup.student.lastName}
                        </span>
                      )}
                      {studentLookup.status === 'not_found' && (
                        <span style={{ color: '#b91c1c' }}>
                          We couldn't find a student with that I.D. at this school. Please double-check and try again.
                        </span>
                      )}
                      {studentLookup.status === 'error' && (
                        <span style={{ color: '#b91c1c' }}>
                          Something went wrong looking up your student. Please try again.
                        </span>
                      )}
                    </small>
                  )}
                </label>
                <Button fullWidth size="large" type="submit" variant="primary"
                        disabled={apptPackageLoading || studentLookup.status === 'loading'}>
                  {apptPackageLoading ? 'Loading appointment options…' : 'Continue'}
                </Button>
              </form>
            )}
            {step === 1 && schoolType === 'Other' && <OtherSchoolTypeForm school={school} />}
            {step === 1 && schoolType !== 'Other' &&
              <StudentIdForm app isAppointments route={route} school={school} schoolType={schoolType}
                             setHasPackage={setHasPackage} />}
          </div>
        </div>
        {!senior && <img className={`${classes.mobileImg} ${classes.img}`} src={apptHeaderImg} />}
      </div>
      {senior && <SeniorCarousel />}
    </>
  )
}

export default ScheduleAppointment
